<template>
  <v-menu
    :position-x="x"
    :position-y="y"
    v-model="showMenu"
    absolute
    offset-y
    style="max-width: 600px"
  >
    <v-list dense>
      <v-list-item
        v-for="status in rowStatusesComputed"
        :key="status.id"
        @click="setStatus(status.name)"
      >
        <v-list-item-icon>
          <v-icon :color="status.color">{{ status.icon }}</v-icon>
        </v-list-item-icon>
        <v-list-item-content>
          <v-list-item-title>{{ status.title }}</v-list-item-title>
        </v-list-item-content>
      </v-list-item>
    </v-list>
  </v-menu>
</template>

<script>
import { DEFAULTS } from '@/constants';

export default {
  props: {
    role: {
      type: String,
      default: ''
    },
    rowStatuses: {
      type: Array,
      default: () => []
    },
    sessionStatus: {
      type: Object,
      default: () => ({})
    },
    analyseLoading: {
      type: Boolean,
      default: true
    },
    importLoading: {
      type: Boolean,
      default: true
    }
  },
  computed: {
    rowStatusesComputed() {
      if (!this.rowStatuses || !this.rowStatuses.length) return [];
      const namedStatuses = this.rowStatuses.map((el) => el.name);
      const statusesToMap =
        this.role === 'customer'
          ? this.showStatuses.customer
          : this.showStatuses.default;

      return statusesToMap
        .filter(
          (name) =>
            !this.disabledStatusesList.find(
              (disabledName) => disabledName === name
            )
        )
        .map((name) => {
          const indexOfStatus = namedStatuses.indexOf(name);

          return {
            ...this.rowStatuses[indexOfStatus],
            icon: this.getStatusByName(name).icon,
            color: this.getStatusByName(name).color
          };
        });
    }
  },
  data: () => ({
    x: 0,
    y: 0,
    showMenu: false,
    isAllowedToImport: false,
    showStatuses: DEFAULTS.SHOW_STATUSES,
    disabledStatusesList: []
  }),
  beforeDestroy() {},
  methods: {
    getStatusByName(statusName) {
      const status = DEFAULTS.ROWS_STATUSES[statusName];
      if (status) return status;
      else {
        console.log('statusName: ', statusName);
        return DEFAULTS.ROWS_STATUSES.not_reviewed;
      }
    },
    showContextMenu({ x, y, selectedRows, disabledStatusesList = [] }) {
      this.disabledStatusesList = disabledStatusesList;
      this.selectedRows = selectedRows;
      this.isAllowedToImport = !!selectedRows.reduce(
        (prev, row) =>
          (prev &=
            row.analyze_status === 'SUCCEED' &&
            row.status.name === 'ready_for_import'),
        true
      );
      this.showMenu = false;
      this.x = x;
      this.y = y;
      this.$nextTick(() => {
        this.showMenu = true;
      });
    },
    hideContextMenu() {
      this.showMenu = false;
    },
    setStatus(status) {
      this.$emit('setStatus', {
        status
      });
    }
  }
};
</script>
